
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetotuljapur() {



    const cardData =
    {
        keyword: 'Pune To Tuljapur Cab',
        heading: 'Mauli Cabs: Pune To Tuljapur Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Tuljapur cab services, ensuring a smooth and spiritual journey to the revered Tuljabhavani Temple. Whether you are visiting for a religious pilgrimage or a peaceful family trip, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on safety, Mauli Cabs guarantees a hassle-free and enriching ride from Pune to Tuljapur.',

        top: 'Top Places to Visit in Tuljapur with Mauli Cabs',

"topPlaces": [
    {
        "title": "Tulja Bhavani Temple",
        "description": "A revered Shakti Peetha, the Tulja Bhavani Temple is dedicated to Goddess Bhavani and is one of the 51 Shakti Peethas. Built in the 12th century, it holds immense spiritual significance and is the family deity of the Bhosale clan, including Chhatrapati Shivaji Maharaj."
    },
    {
        "title": "Ghat Shila Temple",
        "description": "Situated on the western side of Tuljapur, near Ghatshir mountain, the Ghat Shila Temple is an ancient Mahadev Mandir. The temple is adored for its Shivling and the river in front, offering a serene natural atmosphere with birds chirping and peacocks dancing."
    },
    {
        "title": "Kallol Tirth Tank",
        "description": "Located near the Tulja Bhavani Temple, Kallol Tirth Tank is a sacred water tank where devotees take holy dips. It is believed to be a place of spiritual cleansing and is visited by many seeking blessings."
    },
    {
        "title": "Papnashi Tirth",
        "description": "Situated about 500 meters from the Tulja Bhavani Temple, Papnashi Tirth is a revered water tank. The name 'Papnashi' translates to 'destroyer of sins,' and devotees come here to take a dip and purify themselves."
    },
    {
        "title": "Vishnu Tirth",
        "description": "Located to the northeast of the Tulja Bhavani Temple, Vishnu Tirth is a sacred spot where the Ganga, Yamuna, and Saraswati rivers are believed to converge. Devotees visit this place to take a holy bath and seek spiritual benefits."
    },
    {
        "title": "Chintamani Ganpati Temple",
        "description": "This temple is dedicated to Lord Ganesha and is known for its peaceful ambiance. It is a popular spot for devotees seeking blessings and is situated in the vicinity of the Tulja Bhavani Temple."
    },
    {
        "title": "Bharati Buwa's Mutt",
        "description": "A significant religious site in Tuljapur, Bharati Buwa's Mutt is known for its spiritual importance. Visitors can learn about its history and significance from the local residents."
    },
    {
        "title": "Dhakte Tuljapur Temple",
        "description": "An ancient temple located in Tuljapur, Dhakte Tuljapur Temple is known for its historical significance. It is a place where devotees gather to offer prayers and seek blessings."
    },
    {
        "title": "Mudgaleshwar Temple",
        "description": "Situated on the western side of Tuljapur, near Ghatshir mountain, Mudgaleshwar Temple is an ancient Mahadev Mandir. The temple is adored for its Shivling and the river in front, offering a serene natural atmosphere with birds chirping and peacocks dancing."
    },
    {
        "title": "Sant Garibnath Mutt",
        "description": "A revered spiritual center in Tuljapur, Sant Garibnath Mutt is known for its peaceful environment. Devotees visit this place to seek blessings and engage in spiritual activities."
    }
],

"services": [
    {
        "name": "Pune to Tuljapur Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable taxi services from Pune to Tuljapur. Experience a smooth and safe ride to the historic and sacred Tuljapur Temple."
    },
    {
        "name": "Book Pune to Tuljapur Taxi",
        "description": "Book your taxi from Pune to Tuljapur with Mauli Cabs. We provide hassle-free booking and ensure you enjoy a peaceful and comfortable ride to the temple town."
    },
    {
        "name": "Affordable Pune to Tuljapur Cab",
        "description": "Mauli Cabs offers affordable taxi services for your journey from Pune to Tuljapur. Travel comfortably with transparent pricing and no hidden charges."
    },
    {
        "name": "Private Taxi for Tuljapur from Pune",
        "description": "Travel privately with Mauli Cabs from Pune to Tuljapur. Our private taxi service ensures a personalized, comfortable, and peaceful journey to the revered Tuljapur Temple."
    },
    {
        "name": "Tuljapur Pilgrimage by Cab from Pune",
        "description": "Embark on a spiritual pilgrimage from Pune to Tuljapur with Mauli Cabs. Our dedicated drivers and comfortable vehicles ensure a smooth and peaceful trip."
    },
    {
        "name": "Pune to Tuljapur One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip taxi services from Pune to Tuljapur. Choose the option that best suits your schedule and preferences."
    },
    {
        "name": "Comfortable Taxi Ride to Tuljapur",
        "description": "Mauli Cabs provides a comfortable and relaxing taxi ride to Tuljapur. Enjoy a smooth journey in a well-maintained vehicle with professional drivers."
    },
    {
        "name": "Group Travel to Tuljapur",
        "description": "Travel in a group to Tuljapur with Mauli Cabs. Our spacious vehicles are perfect for group travel, ensuring comfort and convenience for everyone."
    },
    {
        "name": "Luxury Taxi for Tuljapur Trip",
        "description": "Experience a luxury taxi ride from Pune to Tuljapur with Mauli Cabs. Enjoy high-end vehicles and a premium travel experience on your pilgrimage."
    },
    {
        "name": "Tuljapur Temple Tour by Taxi",
        "description": "Take a guided temple tour to Tuljapur with Mauli Cabs. Our drivers will ensure a smooth journey, providing you with a relaxing and comfortable visit to the Tuljapur Temple."
    }
],

"tableData": [
    ["Pune to Tuljapur Cab Service", "Book Pune to Tuljapur Taxi"],
    ["Affordable Pune to Tuljapur Cab", "Private Taxi for Tuljapur from Pune"],
    ["Tuljapur Pilgrimage by Cab from Pune", "Pune to Tuljapur One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Tuljapur", "Group Travel to Tuljapur"],
    ["Luxury Taxi for Tuljapur Trip", "Tuljapur Temple Tour by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for your Pune to Tuljapur Cab journey. Our professional drivers ensure that you are picked up and dropped off on time, helping you make the most of your visit to the sacred Tuljapur temple."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Tuljapur trip, we offer a variety of comfortable vehicles, including sedans, SUVs, and premium cars. All our vehicles are air-conditioned, spacious, and well-maintained, ensuring a smooth and relaxing ride throughout your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Tuljapur. They ensure a safe and efficient journey, taking care of traffic conditions and providing a hassle-free travel experience while you focus on your pilgrimage."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Tuljapur Cab booking with no hidden charges. We believe in providing clear, upfront pricing, ensuring that you get the best value for your money without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure and pleasant ride from Pune to Tuljapur."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Tuljapur trip. Whether you're looking for an early morning departure or a late-night return, our customer service team is always available to assist you with your booking anytime."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Tuljapur cab with Mauli Cabs is quick and easy. You can book your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance and a smooth booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Tuljapur journey. Whether you're visiting for a religious pilgrimage or a peaceful retreat, we can tailor the trip to meet your specific needs and preferences."
    }
]




















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Tuljapur with Mauli Cabs?',
            answer: 'Booking your cab from Pune to Tuljapur is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Tuljapur as your destination, then select the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Tuljapur trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Tuljapur, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose a vehicle based on your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Tuljapur trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. You will receive the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Tuljapur take?',
            answer: 'The journey from Pune to Tuljapur typically takes around 5 to 6 hours, depending on traffic conditions. Our drivers ensure a smooth and comfortable journey to your destination.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Tuljapur route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Tuljapur route and are familiar with the best roads to ensure a safe and timely journey. They prioritize your comfort and safety throughout the trip.',
        },
        {
            question: 'Can I book a round trip from Pune to Tuljapur?',
            answer: 'Yes, you can easily book a round trip to Tuljapur. Just provide your return details when making the booking, and we will ensure a smooth return journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Tuljapur?',
            answer: 'Yes, you can customize your trip by making stops for sightseeing or taking breaks along the way. Whether you want to visit specific places or simply take a rest, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride to Tuljapur.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Tuljapur trip?',
            answer: 'Mauli Cabs offers reliable service, competitive pricing, a wide range of vehicle options, and experienced drivers. We ensure that your journey to Tuljapur is comfortable, safe, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sanjay Tiwari",
            position: "Pilgrimage Traveler",
            text: "My trip to Tuljapur with Mauli Cabs was very smooth and comfortable. The driver was friendly, professional, and familiar with the route. I could sit back and enjoy the journey without any worries. Highly recommend Mauli Cabs for anyone traveling to Tuljapur!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Deshmukh",
            position: "Spiritual Traveler",
            text: "I had an excellent experience traveling from Pune to Tuljapur with Mauli Cabs. The car was comfortable, the driver was courteous, and the whole journey was hassle-free. I would definitely use Mauli Cabs again for my future trips!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Tuljapur Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Tuljapur. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Tuljapur with 24x7 online booking support, ideal for pilgrimage and temple tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
  

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Tuljapur Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Tuljapur cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride for your pilgrimage or temple tour to Tuljapur with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Tuljapur cab service, Book Pune to Tuljapur taxi, Affordable Pune to Tuljapur cab, Private taxi for Tuljapur from Pune, Tuljapur pilgrimage by cab from Pune, Pune to Tuljapur one-way or round trip, Comfortable taxi ride to Tuljapur, Group travel to Tuljapur, Luxury taxi for Tuljapur trip, Tuljapur temple tour by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetotuljapur;